<template>
    <div class="conter">
        <div :class="['header_back']">
            <div v-if="bBack" class="back_icon" @click.stop="goback">
                <span></span>
            </div>
            {{$route.meta.title}}
        </div>
        <div class="back_content">
            <pull-to :distance-index="3" :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG"
                :top-load-method="downRefresh" :bottom-load-method="upRefresh" :is-bottom-bounce="isBottomBounce">
                <div v-for="(item,index) in arrMessage" :key="index">
                    <div class="messgae-time">{{item.created_at}}</div>
                    <div class="taber-box">
                        <div class="taber-title">
                            <div class="taber-title-item">{{item.data.detail_msg}}</div>
                            <div v-if="item.is_read == 1" class="time-read">已读</div>
                            <div v-if=" item.is_read == 0" class="time-noread">未读</div>
                        </div>
                        <div class="taber-content">{{item.data.title}}</div>
                        <div class="taber-time"><span class="font-color">验收内容：</span>{{item.data.detail_msg}}</div>
                        <div class="taber-time"><span class="font-color">交付时间：</span>{{item.data.finish_time}}</div>
                    </div>
                    <div class="look-box" @click="gotoInfo(item)">
                        立即查看
                    </div>
                </div>
                <div class="noNews" v-if="arrMessage.length < 1">
                    <div class="new-icon"><img src="@/assets/images/member/v2/plan/news.png" /></div>
                    <div class="new-title">暂无信息</div>
                </div>

            </pull-to>
            <!-- tabs -->
            <div v-if="false">
                <div class="tabs">
                    <div @click="getNav(item, index)" v-for="(item, index) in tabsList" :key="index"
                        :class="nNavIndex == index ? 'tabs-item' : ''">{{ item.name }}</div>
                </div>
                <div class="read">
                    <pull-to :distance-index="3" :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG"
                        :top-load-method="downRefresh" :bottom-load-method="upRefresh" :is-bottom-bounce="isBottomBounce">
                        <div v-show="nNavIndex == 0">
                            <div class="read-item" v-for="(item,index) in arrMessage" :key="index" @click="gotoInfo(item)">
                                <div class="top">
                                    <div class="left font-text1 ">{{item.data.detail_msg}}验收通知</div>
                                    <div class="right">
                                    </div>
                                </div>
                                <div class="bootom font-text ">{{item.data.title}}</div>
                                <div class="bootom font-text ">验收内容：{{item.data.detail_msg}}</div>
                                <div class="bootom font-text ">交付时间：{{item.data.finish_time}}</div>
                                <div class="bootom font-text ">{{item.data.remark}}</div>
                            </div>
                        </div>
                        <div v-show="nNavIndex == 1">
                            <div class="read-item" v-for="(item,index) in arrMessage" :key="index" @click="gotoInfo(item)">
                                <div class="top">
                                    <div class="left font-text1 ">{{item.data.detail_msg}}验收通知</div>
                                    <div class="right">
                                    </div>
                                </div>
                                <div class="bootom font-text ">{{item.data.title}}</div>
                                <div class="bootom font-text ">验收内容：{{item.data.detail_msg}}</div>
                                <div class="bootom font-text ">交付时间：{{item.data.finish_time}}</div>
                                <div class="bootom font-text ">{{item.data.remark}}</div>
                            </div>
                        </div>
                    </pull-to>
                </div>
            </div>
            <div class="home_icon" @click="getHome" :style="{bottom: showInfo == 2 ? '108px':'88px'}">
                <img src="@/assets/images/member/v2/plan/home_icon.png" />
            </div>
        </div>
    </div>
</template>
<script>
import PullTo from "vue-pull-to";
import {
    getNotify,
    getChange,
} from "@/js/house/appindex.js";
let matched = [];
export default {
    components: {
        PullTo,
    },
    data() {
        return {
            bBack: matched.length,
            tabsList: [{
                name: '未读消息',
                path: ''
            },
            {
                name: '已读消息',
                path: ''
            }
            ],
            isBottomBounce: true, // 滚动底部是否开启弹性
            TOP_DEFAULT_CONFIG: {
                pullText: "下拉刷新", // 下拉时显示的文字
                triggerText: "释放更新", // 下拉到触发距离时显示的文字
                loadingText: "加载中...", // 加载中的文字
                doneText: "加载完成", // 加载完成的文字
                failText: "加载失败", // 加载失败的文字
                loadedStayTime: 400, // 加载完后停留的时间ms
                stayDistance: 50, // 触发刷新后停留的距离
                triggerDistance: 70, // 下拉刷新触发的距离
            },
            BOTTOM_DEFAULT_CONFIG: {
                pullText: "加载中...",
                triggerText: "加载中...",
                loadingText: "加载中...",
                doneText: "加载中...",
                failText: "加载中...",
                loadedStayTime: 0,
                stayDistance: 10,
                triggerDistance: 10,
                bShowloading: true,
            },
            nNavIndex: 0,
            nPage: 0,
            arrMessage: [],
            showInfo: false,
        };
    },
    filters: {
        timeago(dateTimeStamp) {
            dateTimeStamp = new Date(dateTimeStamp).getTime();
            var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
            var hour = minute * 60;
            var day = hour * 24;
            var week = day * 7;
            var result;
            var month = day * 30;
            var now = new Date().getTime(); //获取当前时间毫秒
            var diffValue = now - dateTimeStamp; //时间差

            if (diffValue < 0) {
                return;
            }
            var minC = diffValue / minute; //计算时间差的分，时，天，周，月
            var hourC = diffValue / hour;
            var dayC = diffValue / day;
            var weekC = diffValue / week;
            var monthC = diffValue / month;
            if (monthC >= 1 && monthC <= 3) {
                result = " " + parseInt(monthC) + "月前"
            } else if (weekC >= 1 && weekC <= 3) {
                result = " " + parseInt(weekC) + "周前"
            } else if (dayC >= 1 && dayC <= 6) {
                result = " " + parseInt(dayC) + "天前"
            } else if (hourC >= 1 && hourC <= 23) {
                result = " " + parseInt(hourC) + "小时前"
            } else if (minC >= 1 && minC <= 59) {
                result = " " + parseInt(minC) + "分钟前"
            } else if (diffValue >= 0 && diffValue <= minute) {
                result = "刚刚"
            } else {
                var datetime = new Date();
                datetime.setTime(dateTimeStamp);
                var Nyear = datetime.getFullYear();
                var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() +
                    1;
                var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                result = Nyear + "-" + Nmonth + "-" + Ndate
            }
            return result;
        }
    },
    created() {
        let Object = this.$storage.getStorage('sampleroom_info');
        if (Object.sampleroom == 2) {
            this.showInfo = true;
        }
        // this.$oInitData.memberInfo({
        //                 h5_user_id: this.$storage.getStorage("user_id"),
        //             }).then((res) => {
        this.getUserNotify(this.nNavIndex);
        // console.log(res)
        // })
    },
    beforeRouteEnter(to,from,next){
        matched = from.matched;
        next();
    },
    methods: {
        goback(){
            this.$router.go(-1);
        },
        getHome() {
            let Object = this.$storage.getStorage('sampleroom_info');
            this.$router.push({
                path: `/member/v3/index/index?appmob=${this.$storage.getStorage('app_mob')}`,
            });
        },
        //下拉
        downRefresh(loaded) {
            this.nPage = 0;
            this.arrMessage = [];
            this.getUserNotify(this.nNavIndex);
            loaded("done");
        },
        //上拉
        upRefresh(loaded) {
            this.nPage = this.nPage + 1;
            this.getUserNotify(this.nNavIndex);
            loaded("done");
        },
        getUserNotify(e) {
            this.$store.commit("loadSkeleton", {
                bool: true,
                type: "team"
            }); // 页面loading开启
            let _that = this;
            getNotify({
                project_uuid: this.$route.query.project_id,
                page: this.nPage,
                app:1,
                user_id: this.$storage.getStorage('app_user_id') || this.$store.state.app_user_id,
                limit: 10,
            }).then(res => {
                _that.$store.commit("loadSkeleton", {
                    bool: false,
                    type: "team",
                }); // 页面loading关闭
                let arr = res.data.data.result.list;
                _that.arrMessage = _that.arrMessage.concat(arr);
            })
        },
        getNav(item, index) { // tabs 切换
            this.nNavIndex = index;
            this.nPage = 0;
            this.arrMessage = [];
            this.getUserNotify(index);
            this.$router.replace({
                path: item.path
            });
        },
        /**
         * 跳转
         */
        gotoInfo(item) {
           if(item.data && item.data.action=="design"){
                // 3d设计
                this.$router.push({
                    path: '/member/v3/programme/index',
                    query: {
                        appmob: this.$route.query.appmob
                    }
                })
            }else if(item.data && item.data.action=="approva"){
                this.$router.push({
                    path: '/member/v3/contract/survey',
                    query: {
                        contractId:item.data.contract_uuid,
                        appmob: this.$route.query.appmob
                    }
                })
            } else{
                // 验收工单
                getChange({
                    app:1,
                    message_id: item.id,
                    user_id: this.$storage.getStorage('app_user_id') || this.$store.state.app_user_id,
                }).then(res => {
                    this.$router.push({
                        path: '/member/v3/process/detail',
                        query: {
                            id: item.data.rule_report_id,
                            projectmgnid: item.data.project_uuid,
                            appmob: this.$route.query.appmob
                        }
                    })
                })
            }
        },
    },
};
</script>
<style lang='scss' scoped>
.conter {
    box-sizing: border-box;
    background: #F9F9F9;
    -webkit-animation: fadeleftIn .4s;
    animation: fadeleftIn .4s;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
    padding-bottom: env(safe-area-inset-bottom);
    .back_content{
        height: calc(100vh - env(safe-area-inset-bottom) - 180px);
        overflow: hidden;
    }
    .header_back{
        background: #FFF;
        padding-top: 60px;
        box-sizing: border-box;
        height: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        position: relative;
        .back_icon{
            position: absolute;
            left: 50px;
            width: 100px;
            height: 100px;
            display: flex;
            align-items: center;
            span{
                display: block;
                width: 18px;
                height: 18px;
                border: 3px solid #000;
                border-right: 0;
                border-bottom: 0;
                transform: rotate(-45deg);
            }
        }
    }

    .home_icon {
        position: fixed;
        right: 8px;

        img {
            width: 112px;
            height: 112px;
        }
    }

    .noNews {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%);

        .new-icon {
            img {
                width: 216px;
                height: 162px;
            }
        }

        .new-title {
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            margin-top: 54px;
            color: rgba(0, 0, 0, 0.5);
        }
    }


    .messgae-time {
        width: 246px;
        padding: 6px 12px;
        text-align: center;
        background: rgba(53, 93, 75, 0.05);
        font-size: 20px;
        font-weight: 400;
        color: #9D9D9D;
        margin: 0 auto;
        margin-top: 48px;
        margin-bottom: 32px;
        border-radius: 8px;
    }

    .taber-box {
        width: 686px;
        background: #FFFFFF;
        border-radius: 24px 24px 0 0;
        margin: 0 auto;
        padding: 48px 32px;
        border-bottom: 1px solid rgba(211, 211, 211, 0.3);

        .taber-title {
            display: flex;
            justify-content: space-between;

            .taber-title-item {
                font-size: 32px;
                font-weight: bold;
                color: #333333;
                line-height: 48px;
            }

            .time-read {
                /* width: 48px; */
                font-size: 24px;
                color: #DDDDDD;
                line-height: 48px;
            }

            .time-noread {
                /* width: 48px; */
                font-size: 24px;
                color: #999999;
                line-height: 48px;
            }
        }

        .taber-content {
            margin: 32px 0;
            font-size: 24px;
            color: #666666;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            line-height: 48px;
        }

        .taber-time {
            font-size: 24px;
            color: #333333;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            line-height: 48px;

            .font-color {
                font-size: 24px;
                color: #666666;
                line-height: 48px;
            }
        }
    }

    .look-box {
        width: 686px;
        background: #FFFFFF;
        border-radius: 0 0 24px 24px;
        margin: 0 auto;
        padding: 32px;
        text-align: center;
        font-size: 28px;
        color: #355D4B;
        margin-bottom: 48px;
    }

    .tabs {
        height: 80px;
        text-align: center;
        line-height: 80px;
        background: #FFFFFF;
        border-radius: 12px;
        overflow: hidden;

        display: flex;

        div {
            flex: 2;
            font-size: $bigSize;
            font-weight: 400;
            color: #858585;
        }

        .tabs-item {
            background: $deepGreen;
            color: #FFFFFF;
        }
    }

    .read {
        padding-top: 24px;
        height: calc(100vh - 164px);
        overflow-y: auto;

        // animation: fadetransform 0.4s;

        .read-item {
            padding-bottom: 18px;
            margin-bottom: 32px;
            border-bottom: 1px dashed rgba(228, 228, 228, 1);

            .top {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .left {
                    max-width: 550px;
                }

                .right {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    img {
                        width: 32px;
                        height: 32px;
                    }

                }
            }
        }

        .bootom {
            padding-top: 8px;
            max-width: 600px;

        }
    }
}

div {
    box-sizing: border-box;
}

.action-block action-block-bottom {
    display: none;
    background: #F9F9F9;
}

// 默认灰字体
.font-text {
    font-size: $smallSize;
    font-weight: 400;
    color: #A2A2A2;
}


// 默认字体
.font-text1 {
    font-size: $bigSize;
    font-weight: 500;
    color: #444444;
}


// 默认字体
.font-text2 {
    //28
    font-size: $bigSize;
    font-weight: 400;
    color: #A2A2A2;
}

// 超出一行省略
.omit {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

// 超出2行省略
.omit-s {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

@keyframes fadetransform {
    0% {
        opacity: 1;
        transform: translateX(0px);
    }

    100% {
        opacity: 0;
        transform: translateX(-30px);
    }
}

@keyframes fadeleftIn {
    0% {
        -webkit-transform: translate3d(100%, 0, 0);
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }

    100% {
        -webkit-transform: none;
        transform: none;
    }
}

@-webkit-keyframes fadeleftIn {
    0% {
        -webkit-transform: translate3d(100%, 0, 0);
    }

    100% {
        -webkit-transform: none;
    }
}
</style>
